interface Props {
  level: 'LOW' | 'MEDIUM' | 'HIGH' | null;
}

const LABELS: Record<Exclude<Props['level'], null>, string> = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High'
};

const CLASSES: Record<Exclude<Props['level'], null>, string> = {
  LOW: 'bg-emerald-500/10 text-emerald-200 ring-1 ring-emerald-400/50',
  MEDIUM: 'bg-amber-500/10 text-amber-200 ring-1 ring-amber-400/50',
  HIGH: 'bg-red-500/10 text-red-200 ring-1 ring-red-400/50'
};

export function RiskLevelTag({ level }: Props) {
  if (!level) {
    return (
      <span className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium text-slate-300/70 ring-1 ring-slate-500/30">
        N/A
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${CLASSES[level]}`}
    >
      {LABELS[level]}
    </span>
  );
}
